export const selectArchivedOpportunitiesByReasonData = (state) =>
  state.capture.archivedOpportunitiesByReason.data;

export const selectArchivedOpportunitiesByReasonLoading = (state) =>
  state.capture.archivedOpportunitiesByReason.isLoading;

export const selectArchivedOpportunitiesByReasonError = (state) =>
  state.capture.archivedOpportunitiesByReason.error;
